module.exports = __webpack_public_path__ + "hyperion-v2-static/img/baselayer-light-btn-60x60.485b4b14.png";